import React, { lazy } from 'react'
import { RouteObject } from 'react-router'

const CarParkInstallmentListing = lazy(
  () => import('./CarParkInstallmentListing')
)

const CarParkInstallmentDetail = lazy(
  () => import('./CarParkInstallmentDetail')
)

const PurchaserInstallmentRoutes: RouteObject[] = [
  {
    path: ':saleID/car-park-installment',
    children: [
      {
        path: '',
        element: <CarParkInstallmentListing />,
      },
      {
        path: ':carParkId',
        element: <CarParkInstallmentDetail />,
      },
    ],
  },
]

export default PurchaserInstallmentRoutes
